import { IServerImage } from "./services/registry/ServerImageService";
import { Link } from "@mui/material";
import * as React from "react";
import { IBackendImage } from "./services/registry/BackendImageService";

export const getBackendImageIdLink = (backendImageId: string, backendImages: IBackendImage[]) => {
  const link = (
    <Link onClick={() => window.open(`${window.location.origin}/backend-images/?id=${backendImageId}`)}>
      {backendImageId}
    </Link>
  );
  const backendImage = backendImages.find((t) => t.id === backendImageId);
  if (!backendImage) {
    return "UNKNOWN";
  }
  const latestBackendImageFromBranch = backendImages
    .filter((t) => t.branch === backendImage.branch)
    .sort((a, b) => b.creationDate - a.creationDate)[0];
  const isLatest = backendImage.id === latestBackendImageFromBranch.id;
  if (isLatest) {
    return (
      <>
        {link}
        {" ("}
        <b style={{ color: "green" }}>latest</b>
        {` from ${backendImage.branch})`}
      </>
    );
  } else {
    return (
      <>
        {link}
        {" ("}
        <b style={{ color: "red" }}>outdated</b>
        {` from ${backendImage.branch})`}
      </>
    );
  }
};

export const getServerImageIdLink = (serverImageId: string, serverImages: IServerImage[]) => {
  const link = (
    <Link onClick={() => window.open(`${window.location.origin}/server-images/?id=${serverImageId}`)}>{serverImageId}</Link>
  );
  const serverImage = serverImages.find((t) => t.id === serverImageId);
  if (!serverImage) {
    return "UNKNOWN";
  }
  const sortedBranchServerImages = serverImages
    .filter((t) => t.branch === serverImage.branch)
    .sort((a, b) => b.creationDate - a.creationDate);

  const isLatest = serverImage.id === sortedBranchServerImages[0].id;
  if (isLatest) {
    return (
      <>
        {link}
        {" ("}
        <b style={{ color: "green" }}>latest</b>
        {` from ${serverImage.branch})`}
      </>
    );
  }

  if (sortedBranchServerImages[0].status !== "valid") {
    const latestValidServerImageFromBranch = sortedBranchServerImages.find((t) => t.status === "valid");
    const isLatestValid = latestValidServerImageFromBranch && serverImage.id === latestValidServerImageFromBranch.id;
    if (isLatestValid) {
      return (
        <>
          {link}
          {" ("}
          <b style={{ color: "green" }}>latest valid</b>
          {` from ${serverImage.branch})`}
        </>
      );
    }
  }

  return (
    <>
      {link}
      {" ("}
      <b style={{ color: "red" }}>outdated</b>
      {` from ${serverImage.branch})`}
    </>
  );
};
